import { IconButton } from '@mui/material';
import styled from 'styled-components';

import Menu, { MenuItem } from 'components/v2/Menu';
import { COLORS } from 'theme';

export const KebabMenuControlButton = styled(IconButton)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    margin: 0;
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    svg {
      path {
        fill: ${COLORS.black50};
      }
    }

    :hover {
      svg {
        path {
          fill: ${COLORS.kinetikBlack};
        }
      }
    }
  }
`;

export const KebabMenuContextMenu = styled(Menu)`
  .MuiPaper-root {
    min-width: 110px;
  }
`;

export const KebabMenuContextMenuItem = styled(MenuItem)`
  gap: ${({ theme }) => theme.spacing.s1};
`;
